const inicialState = {
  tab: '0',
  totalMateriaisavencer: 0,
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  motivo: '',
  peso: 0,
  observacao: '',
  imprimir: false,
  permissaoConsultaDescarteMateriais: false,
  permissaoDescarteMateriais: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/store/descarte.state.js